import { AxiosInstance } from "axios";
import { getBoardApiUrl } from "helpers";
import { SendToRequestModel } from "models/SendToRequestModel";
import { SendToTargetModel } from "models/SendToTargetModel";

export class SendToApi {
  constructor(private axios: AxiosInstance) {}

  async getPreview(): Promise<SendToTargetModel[]> {
    const url = getBoardApiUrl(`sendTo/`);
    const response = await this.axios.get<SendToTargetModel[]>(url);

    return response.data;
  }

  async sendTo(agendaItemId: number, targets: SendToRequestModel[]) {
    if (!agendaItemId) throw new Error("agendaItemId is required");
    const url = getBoardApiUrl(`sendTo/${agendaItemId}`);
    const response = await this.axios.post(url, targets);

    return response.data;
  }
}
